import { Grid, Paper, Stack } from "@mui/material";
import React from "react";

import { cn } from "../../../../../utils/styling";

type StepColumnProps = {
  children: React.ReactNode;
  className?: string;
  paperClassName?: string;
  subtitle?: string | undefined;
  subtitleClassName?: string;
  title: string;
  titleClassName?: string;
  xs?: number;
};

export const StepColumn = ({
  children,
  className,
  paperClassName,
  subtitle,
  subtitleClassName,
  title,
  titleClassName,
  xs = 6,
}: StepColumnProps) => {
  return (
    <Grid className={className} item xs={xs}>
      <Paper className={cn("p-10 shadow-elevation400 border-ds-subtle", paperClassName)}>
        <Stack className="h-full flex-col">
          <Stack className="w-full flex-col items-start gap-4">
            <div>
              <h1 className={cn("font-ds-headline-xl", titleClassName)}>{title}</h1>
              {subtitle && <p className={cn("mt-4 font-ds-body-regular-md", subtitleClassName)}>{subtitle}</p>}
            </div>
          </Stack>
          {children}
        </Stack>
      </Paper>
    </Grid>
  );
};
